var exports = {
  "kL": "x9245d464--b15a17--container",
  "$h": "x9245d464--b15a17--closed",
  "Qs": "x9245d464--b15a17--content",
  "R_": "x9245d464--b15a17--heading",
  "DD": "x9245d464--b15a17--title",
  "c5": "x9245d464--b15a17--arrow-wrapper",
};

module.exports = exports;
